import styled from "styled-components";
const MyDiv = styled.div`
.grid_header {
    display: grid;
     grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 0.75rem;
     margin-bottom: 0.75rem;
  }
.row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 0.75rem;
    margin-bottom: 0.5rem;
    align-items: center;
  }
.grid_input{
display: flex;
grid-template-columns: 2fr auto;
}
`
export default MyDiv